export const webserver = (method, data, callback) => {
    console.log('🌐 Webserver - Método:', method);
    console.log('📤 Webserver - Data:', data);
    
    //var wsUrl = "http://localhost/erp/ws/bos/" + method;
    //var wsUrl = "https://ai-bos.xyz/erp/ws/bos/" + method;
    var wsUrl = "https://erp.ai-bos.co/api/" + method;
    
    console.log('🔗 Webserver - URL:', wsUrl);
    
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    console.log('📨 Webserver - Enviando request...');
    
    // Timeout personalizado
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        console.log('⏰ Webserver - TIMEOUT tras 30 segundos');
        controller.abort();
    }, 60000); // 30 segundos timeout
    
    fetch(wsUrl, {
        ...options,
        signal: controller.signal
    })
        .then(res => {
            clearTimeout(timeoutId);
            console.log('📥 Webserver - Response status:', res.status);
            
            if (res.status === 401 || res.status === 403) {
                console.warn('🔒 Sesión inválida o token vencido. Redirigiendo a Login...');
                try {
                    // Intentar redirigir con router si existe en ventana global
                    if (window && window.appRouter) {
                        window.appRouter.push({ name: 'Login', params: { nextUrl: window.location.pathname } });
                    } else {
                        // Fallback: redirección directa a la ruta de login
                        window.location.href = '/Login';
                    }
                } catch (e) {
                    window.location.href = '/Login';
                }
                throw new Error(`Auth Error: ${res.status} ${res.statusText}`);
            }

            if (!res.ok) {
                throw new Error(`HTTP Error: ${res.status} ${res.statusText}`);
            }
            
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                console.log('📄 Webserver - Response text length:', text.length);
                
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ Webserver - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        console.log('🔧 Webserver - JSON extraído, longitud:', jsonText.length);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            console.error('❌ Webserver - Error al parsear JSON extraído:', parseError);
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        console.error('❌ Webserver - Error al parsear JSON:', parseError);
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(response => {
            console.log('✅ Webserver - Response data:', response);
            callback(response);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            console.error('❌ Webserver - Error:', err);
            
            // Llamar callback con error estructurado
            callback({
                error: true,
                message: err.name === 'AbortError' ? 'Timeout - La operación tardó mucho tiempo' : err.message,
                originalError: err
            });
        });
}

export const fe_ws_old = (method, data, callback) => {
   //var wsUrl = "https://aipos.ngmpos.co/ws/fe_ws/" + method;
     var wsUrl = "https://ai-bos.xyz/erp/ws/fe_ws/" + method;
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    fetch(wsUrl, options)
        .then(res => {
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ FE WS Old - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(callback)
        .catch(err => console.log(err))
}


export const fe_ws = (method, data, callback) => {
    console.log('🌐 Webserver - Método:', method);
    console.log('📤 Webserver - Data:', data);
    
    //var wsUrl = "http://localhost/erp/ws/fe_ws/" + method;
    var wsUrl = "https://ai-bos.xyz/erp/ws/fe_ws/" + method;
    
    console.log('🔗 Webserver - URL:', wsUrl);
    
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    console.log('📨 Webserver - Enviando request...');
    
    // Timeout personalizado
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        console.log('⏰ Webserver - TIMEOUT tras 30 segundos');
        controller.abort();
    }, 60000); // 30 segundos timeout
    
    fetch(wsUrl, {
        ...options,
        signal: controller.signal
    })
        .then(res => {
            clearTimeout(timeoutId);
            console.log('📥 Webserver - Response status:', res.status);
            
            if (!res.ok) {
                throw new Error(`HTTP Error: ${res.status} ${res.statusText}`);
            }
            
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                console.log('📄 FE Webserver - Response text length:', text.length);
                
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ FE Webserver - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        console.log('🔧 FE Webserver - JSON extraído, longitud:', jsonText.length);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            console.error('❌ FE Webserver - Error al parsear JSON extraído:', parseError);
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        console.error('❌ FE Webserver - Error al parsear JSON:', parseError);
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(response => {
            console.log('✅ Webserver - Response data:', response);
            callback(response);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            console.error('❌ Webserver - Error:', err);
            
            // Llamar callback con error estructurado
            callback({
                error: true,
                message: err.name === 'AbortError' ? 'Timeout - La operación tardó mucho tiempo' : err.message,
                originalError: err
            });
        });
}

export const NGMGpt = (method, data, callback) => {
    var ws_server=window.location.host;
    ws_server="mi.ngmpos.co";
    var wsUrl = "https://" + ws_server + "/chatgpt/" + method;
    console.log("webserver",wsUrl);
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    fetch(wsUrl, options)
        .then(res => {
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ NGMGpt - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(callback)
        .catch(err => console.log(err))
}



export const getToday = () => {
    const now = new Date();
    const options = {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };
    const dateParts = now.toLocaleString('es-ES', options).split('/');
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
}

export const getdays_ago = (days) => {
    const now = new Date();
    now.setDate(now.getDate() + days); // Resta o suma días
    
    // Configuración para Madrid (España)
    const options = {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };
    
    // Formatea la fecha según la zona horaria
    const dateStr = now.toLocaleString('es-ES', options);
    const [day, month, year] = dateStr.split('/');
    
    // Devuelve en formato YYYY-MM-DD
    return `${year}-${month}-${day}`;
}

export const get_UUID = () => {
    var dt = new Date().getTime();
    var uuid = "xxxx-xxxx-4xxx-yxxx-xxxx".replace(/[xy]/g, function(c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}

// Importar las nuevas utilidades
import { getDefaultCurrency, getCountryLocale } from '../utils/countryUtils.js';

export const formatCurrency = (value, currency = null, options = {}) => {
    if (!value && value !== 0) return "0";

    // Obtener moneda y locale según el país de la empresa
    const finalCurrency = currency || getDefaultCurrency();
    const locale = getCountryLocale();

    // Monedas que siempre usan 2 decimales (centavos)
    const useCents = ['EUR', 'USD', 'CAD', 'GBP'].includes(finalCurrency);

    const currencyOptions = {
        style: "currency",
        currency: finalCurrency,
        minimumFractionDigits: useCents ? 2 : 0,
        maximumFractionDigits: useCents ? 2 : 2, // Max 2 decimales, pero solo si los tiene
        ...options
    };

    return new Intl.NumberFormat(locale, currencyOptions).format(value);
}

export const getStoreCurrency = () => {
    // Usar la nueva utilidad que considera el Country_IdentificationCode
    return getDefaultCurrency();
}

export const formatNumber = (value, locale = null, options = {}) => {
    if (value === null || value === undefined || isNaN(value)) return "0";
    
    // Usar locale del país actual si no se especifica
    const finalLocale = locale || getCountryLocale();
    
    const numberOptions = {
        maximumFractionDigits: 2,
        ...options
    };
    
    return new Intl.NumberFormat(finalLocale, numberOptions).format(value);
}